// Brand specific configuration
// This file is required for each brand
// Don't include any secrets here, they should be in the .env file
import { BaseBrandThemeConfig } from '@aspendental/shared-components-web';

const config: BrandThemeConfig = {
	...BaseBrandThemeConfig,
	name: 'Chapter Aesthetic Studio',
	logo: {
		dark: 'https://images.ctfassets.net/m8zwsu9tyucg/63seFEFm7hvfsGEMVq8qXO/30bc3a5c84aa89dff24496094c214148/Chapter_Primary.svg',
		light: 'https://images.ctfassets.net/m8zwsu9tyucg/4YaSdfk2hJAo0xLldfr0M6/f26c830f2050613803b74c6382a5631a/chapter-logo-light.svg',
	},
	services: {
		prod: {
			...BaseBrandThemeConfig.services.prod,
			BEFFE_GRAPHQL_URL: 'https://www.mychapter.com/api/bff',
			GOOGLE_MAP_API_KEY: 'AIzaSyCKsIikTSPn_UdQ0aNQMoNLjSqprL7zspI',
		},
		nonprod: {
			...BaseBrandThemeConfig.services.nonprod,
			BEFFE_GRAPHQL_URL: 'https://wwwstg.mychapter.com/api/bff',
			GOOGLE_MAP_API_KEY: 'AIzaSyA4Dl0kUx2sOSqHs_qbQIeGXsQbJTc3ZbE',
		},
	},
	siteURL: 'https://www.mychapter.com',
	features: {
		redirects: [],
		rewrite: {},
		favIcons: {},
		sitemap: {
			additionalSitemapIndexes: [],
			additionalSitemapUrls: [],
		},
		analytics: {
			enabled: true,
			vwoAccountId: '638655',
			gtmId: 'GTM-M4PFZQM',
		},
		sentry: {
			enabled: true,
		},
		chat: {
			enabled: false,
			chatBotURL:
				'https://aspendental.amelia.com/Amelia/ui/aspencallcenter/chat?embed=iframe&domainCode=aspencallcenter',
			isIconButton: false,
		},
		revSpringChat: {
			enabled: false,
		},
		notFoundPage: {
			desktopBackgroundImage:
				'https://images.ctfassets.net/m8zwsu9tyucg/5fhlfO83zrA0Eh0c76nuPW/dab516d6d7acb1352edab3a526fe43fa/Hero_v2_Desktop.png?q=90&fit=fill&f=face&bg=rgb%3A321032&fm=webp',
			mobileBackgroundImage:
				'https://images.ctfassets.net/m8zwsu9tyucg/12b9aOLC9Y5cmS2kw0N2ww/9ec2783a066ace40d63e639d7d326ab8/m.hero.png?q=90&fit=fill&f=face&bg=rgb%3A321032&fm=webp',
		},
		livePreview: {
			local: 'https://local.mychapter.com:8443',
			stage: 'https://wwwstg.mychapter.com',
			prod: 'https://www.mychapter.com',
		},
		footer: {
			lite: true,
			withSimpleLayout: false,
		},
		blogs: {
			root: '',
		},
		migration: {
			paths: [],
		},
		otherApps: {
			facilityDetailsBasePath: '',
		},
		salesforce: {
			enabled: false,
		},
		realUserMonitoring: {
			enabled: true,
			faroApiKey: '159f3c52f1a30c834fe8e0cef336858a',
		},
	},
	featureFlags: {
		...BaseBrandThemeConfig.featureFlags,
		hideHeaderFacilityLocator: true,
		hideHeaderSchedulingButton: true,
	},
	contentfulAppId: 'Chapter - Scheduling' as ContentfulAppId,
	themeId: 'chapter' as TagThemeType,
	themeColor: '#182464',
	googleMapBusinessQuery: 'https://www.google.com/maps/search/?api=1&query=Chapter Aesthetic Studio, [address]',
	receiveEmail: true,
};

export default config;
